import React, { Component } from 'react';
import { FormModalContainer, FormModalContent, SelectContainer } from '../style';
import { BackIconContainer } from '../../style';
import { Text } from '../../../../UI/Text';
import { WorkoutTypePreviewItem } from '../Previews/WorkoutTypePreviewItem';
import { ChooseWorkoutSecondStepFactory } from '../SecondStepFactory';
import { isEmptyObject } from '../../../../../Utils';

export class ChooseWorkoutModal extends Component {
    state = {
        selectedItemId: null,
        nextWindowId: null,
    };

    selectActions = selectedItemId => ({
        selectItem: () => {
            if (this.props.notForLeaderboards && selectedItemId !== 2)
                this.props.onSelect(this.props.initialModalType, {
                    type: this.props.initialModalType,
                    content_type: this.props.itemId,
                    workout_id: this.props.workoutsOfTheDay.id,
                });
            this.setState({ selectedItemId, nextWindowId: selectedItemId });
        },
    });

    closeNextWindow = () => this.setState({ nextWindowId: null });

    checkIfItemDisabled = index => {
        if (this.props.notForLeaderboards) {
            if (
                index === 0 &&
                !Array.isArray(this.props.workoutsOfTheDay) &&
                isEmptyObject(this.props.workoutsOfTheDay)
            )
                return true;
            if (
                index === 1 &&
                !Array.isArray(this.props.workoutOfTheWeek) &&
                isEmptyObject(this.props.workoutOfTheWeek)
            )
                return true;
        }

        return false;
    };

    render() {
        const {
            props: { onClose, title, notForLeaderboards, ...props },
            state: { nextWindowId },
            selectActions,
            closeNextWindow,
            checkIfItemDisabled,
        } = this;

        return nextWindowId !== null ? (
            <ChooseWorkoutSecondStepFactory
                notForLeaderboards={notForLeaderboards}
                {...props}
                leaderboardsType={nextWindowId}
                onClose={closeNextWindow}
            />
        ) : (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        {title}
                    </Text>

                    <BackIconContainer onClick={onClose}>
                        <i className="fas fa-chevron-left" />
                    </BackIconContainer>

                    <SelectContainer>
                        {[...Array(3)].map((item, index) => (
                            <WorkoutTypePreviewItem
                                isDisabled={checkIfItemDisabled(index)}
                                type={index}
                                {...selectActions(index)}
                                key={index}
                            />
                        ))}
                    </SelectContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}

ChooseWorkoutModal.defaultProps = {
    type: 0,
    title: 'Choose workout',
    onClose: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/GymTvConfigurationsModal/Modals/ChooseWorkoutModal.js